export { default as ExportOptionsDialog } from './ExportOptionsDialog'

// types
export type ExportConfirmationProps = {
  networkName: string
  onConfirm: (options: ExportOptions) => Promise<void>
}

export type ExportOptions =
  | { type: ExportType.Release }
  | { type: ExportType.Import; historyLimit: number }

// enums
export enum ExportType {
  Release = 'release',
  Import = 'import',
}
